import { omit } from 'lodash-es';
import { venomHistory } from 'client/utils/history/venom-history';
import { getSrpBrowserQuery } from 'site-modules/shared/utils/inventory/srp-utils';
import { BODY_TYPE, MAKE, MODEL, RADIUS } from 'site-modules/shared/constants/allowed-inventory-request-params';

export const MINI_INVENTORY_COUNT = { true: 8, false: 9 };
export const CONSTANT_FILTERS = ['make', 'model', 'initialUrlPattern', 'pageSize'];
export const EXCLUDED_FILTER_TYPES = [BODY_TYPE, MAKE, MODEL, RADIUS];

export function getInitialSearchFilter({ makeSlug, modelSlug, year }) {
  return {
    make: [makeSlug],
    model: [`${makeSlug}|${modelSlug}`],
    year: `${year}`,
  };
}

export function getUnknownLocationSearchFilter(isInternational) {
  return isInternational ? { national: true } : {};
}

export function addFiltersToQuery(pathname, filter) {
  const query = getSrpBrowserQuery(omit(filter, CONSTANT_FILTERS));

  venomHistory.push(`${pathname}${query ? `?${query}` : ''}`);
}
